import { render, staticRenderFns } from "./update.vue?vue&type=template&id=77b1cb0f&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"
import style0 from "./update.vue?vue&type=style&index=0&id=77b1cb0f&prod&lang=scss"
import style1 from "./update.vue?vue&type=style&index=1&id=77b1cb0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1cb0f",
  null
  
)

export default component.exports